var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTkv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0757211538 20.9954196 0.0757211538 20.9954196 17.3076769 0 17.3076769"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ADPKD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Prognostic-Tools-Option-1",
    transform: "translate(-763.000000, -613.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(763.000000, 613.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1325935,15.555273 L17.2565065,15.555273 L15.5309304,15.555273 L12.07955,15.555273 L10.3538978,15.555273 L6.90259348,15.555273 L5.1769413,15.555273 L1.72563696,15.555273 L1.72563696,0.951907624 C1.72563696,0.468219437 1.33911522,0.0757057005 0.86281087,0.0757057005 C0.386506522,0.0757057005 -1.52173913e-05,0.468219437 -1.52173913e-05,0.951907624 L-1.52173913e-05,16.4314749 C-1.52173913e-05,16.9152404 0.386506522,17.3076769 0.86281087,17.3076769 L20.1325935,17.3076769 C20.6089739,17.3076769 20.9954196,16.9152404 20.9954196,16.4314749 C20.9954196,15.9477867 20.6089739,15.555273 20.1325935,15.555273",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.9056366,12.9997104 L3.95265191,12.9997104 C4.3314165,12.9797952 12.8614687,12.4337015 17.8792836,4.09952111 L18.2579704,5.89921953 C18.3612487,6.35142764 18.8225426,6.64102051 19.2940944,6.54930612 C19.765724,6.45751686 20.0732273,6.01751238 19.9848697,5.56208491 L19.1713107,1.67953393 C19.125461,1.45844609 18.9889224,1.26498487 18.7938672,1.14010356 C18.5987342,1.01627041 18.3612487,0.972022898 18.1316897,1.01739345 L14.1018178,1.80112101 C13.6313539,1.90062176 13.3306892,2.34392047 13.4270511,2.79829978 C13.5223251,3.25267908 13.9778684,3.54998345 14.4505859,3.46485752 L16.45981,3.07134662 C11.9423001,10.7722111 4.19930739,11.2840897 3.8586213,11.3016839 C3.37207122,11.3138127 2.98771141,11.7041042 3.00030064,12.1727835 C3.01405553,12.6415376 3.41908652,13.0118391 3.9056366,12.9997104",
    id: "Fill-4",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTkv);
export default __webpack_public_path__ + "static/media/icon-tkv.12bcf5961cde49cd8ff37aacc86d4309.svg";
export { ForwardRef as ReactComponent };